import React from 'react';

import {MyScoresWidgetCompetitionPlaceholder} from "../../placeholders/my-scores-widget.competition-placeholder";
import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import {MyScoresWidgetTerms} from "../../../my-scores-widget.terms";
import {WithTerms} from "../../../../../core/components/composers/with-terms";
import styles from "../../../../all-scores-widget/styles/all-scores-widget.module.scss";
import classnames from "classnames";

export class MyScoresWidgetMobilePlaceholderProps extends BaseProps {
  numOfGames: Number = 4;
  i18n: MyScoresWidgetTerms;
  shouldRenderHeader: Boolean;
  includeFeaturedGamesWidget: Boolean;
  isSmallView: Boolean;
  controller;
}

export const MyScoresWidgetMobilePlaceholder = WithTerms((props: MyScoresWidgetMobilePlaceholderProps) => {
  return (
    <>
      {
        props.includeFeaturedGamesWidget ? <div
          className={classnames(styles.featured_games_placeholder, {[styles.small_view]: props.isSmallView || props.controller?.device.isSmallView}, props.className)}/> : null
      }
      <div
        className={['my-scores-widget-mobile-placeholder-container', props.shouldRenderHeader ? 'my-scores-widget-mobile-placeholder-container-margin' : ''].join(' ')}>
        <div className={'my-scores-widget-mobile-placeholder-date-container'}>
          <div className={'my-scores-widget-mobile-placeholder-day-container'}>
            <div className={'my-scores-widget-mobile-placeholder-line'}/>
            {' '}
            <div className={'my-scores-widget-mobile-placeholder-line'}/>
          </div>
        </div>
        <div className={'my-scores-widget-mobile-placeholder-section-title'}>
          {
            ' '
          }
        </div>
        <MyScoresWidgetCompetitionPlaceholder {...props} numOfGames={2}/>
        <MyScoresWidgetCompetitionPlaceholder {...props} numOfGames={4}/>
        <div className={'my-scores-widget-mobile-placeholder-section-title'}>
          {
            ' '
          }
        </div>
        <div className={'my-scores-widget-mobile-placeholder-date-container'}>
          <div className={'my-scores-widget-mobile-placeholder-day-container'}>
            <div className={'my-scores-widget-mobile-placeholder-line'}/>
            {
              ' '
            }
            <div className={'my-scores-widget-mobile-placeholder-line'}/>
          </div>
        </div>
        <MyScoresWidgetCompetitionPlaceholder {...props} numOfGames={1}/>
        <MyScoresWidgetCompetitionPlaceholder {...props} numOfGames={3}/>
      </div>
    </>
  )
});
